<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '60vh',
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    chartData: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })
      this.setOptions(this.chartData)
    },
    setOptions({ keyData, valueData } = {}) {
      var option

      option = {
        title: {
          text: this.title,
          x: 'center',
          y: 'bottom',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bolder',
          },
        },
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: 12,
          right: 70,
          containLabel: true,
        },
        // grid: {
        //   left: 0,
        //   right: 15,
        //   bottom: 25,
        //   top: 40,
        //   containLabel: true,
        // },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: { show: true },
          },
        },
        xAxis: {
          name: '使用時間',
          boundaryGap: false,
          type: 'category',
          axisLabel: {
            formatter: function (value) {
              return value.split('').join('\n')
            },
          },
          data: keyData,
        },
        yAxis: {
          name: '工作互動數',
          type: 'value',
        },
        series: [
          {
            type: 'line',
            data: valueData,
            color: ['#FFC107'],
          },
        ],
      }

      if (option && typeof option === 'object') {
        this.chart.setOption(option)
      }

      window.addEventListener('resize', this.chart.resize)
    },
  },
}
</script>
